import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Form, Modal } from "react-bootstrap";
import { inboxServices } from "../../../APIServices/SitePilotManagement/inboxServices";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";

const TimelineNoteHistory = ({ show, hide, title, propertyId, contactId, inboxId, uniqueId }) => {
  const [history, setHistory] = useState([]);

  const getTimelineHistory = async () => {
    let data = await inboxServices.getTimelineHistory(propertyId, contactId, inboxId || null, uniqueId, "note")
    setHistory(buildNoteTimeline(data?.data || []))
  }

  useEffect(() => {
    if (show && propertyId && uniqueId) {
      getTimelineHistory()
    }
  }, [show, propertyId, contactId, inboxId, uniqueId]);

  const buildNoteTimeline = (timeline) => {
    return timeline.map((item) => {
      const date = dayjs(item.timelineDT);
      return {
        id: item._id,
        dateGroup: date.format("DD MMM YYYY"),
        time: date.format("hh:mm A"),
        previousValue: item?.previousValue,
        currentValue: item?.currentValue,
        activityByName: item?.activityByName,
        action: item.action,
      }
    });
  };

  return (
    <Modal show={show} onHide={hide}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 15 }}>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="preview-scroll p-0">
          {history?.map((item, index) => (
            <div key={index}>
              <div className="mb-2">
                <div className="hstack gap-2 justify-content-between">
                  <Form.Label className="mb-0"><span className="text-capitalize">{item?.action} By:</span> {item?.activityByName}</Form.Label>
                  <Form.Label className="mb-0">{item.dateGroup} at {item.time}</Form.Label>
                </div>
                <div className="hstack gap-2">
                  <Form.Control
                    rows={1}
                    as={`textarea`}
                    className={`${item?.action === "updated" ? "bg-primary-subtle" : item?.action === "deleted" ? "text-capitalize bg-danger-subtle" : "text-capitalize bg-success-subtle"}`}
                    readOnly
                    disabled
                    value={item?.action === "updated" ? item?.previousValue : `${item?.action} Note`}
                    style={{ resize: "none" }}
                    />
                  <HiOutlineArrowNarrowRight style={{ fontSize: 45 }} className="text-secondary" />
                  <Form.Control
                    as={`textarea`}
                    rows={1}
                    readOnly
                    disabled
                    style={{ resize: "none" }}
                    value={item?.currentValue}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TimelineNoteHistory;
